import React, { useState } from "react";
import "./LoginScreen.css";
import { LinearGradient } from "react-text-gradients";
import { auth } from "../../../config/firebase.js";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useDispatch } from "react-redux";
import { setUser } from "../../../store/reducers/authSlice";
import { errorToast, successToast } from "../../../services/toastService";

export default function LoginScreen() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    console.log("fn called");
    try {
      await signInWithEmailAndPassword(auth, email, password).then(userCred => {
        const user = userCred._tokenResponse;
        successToast("Login success.");
        dispatch(setUser(user));
      });
    } catch (error) {
      errorToast("Invalid login credentials.");
      console.log("Login error:", error.message);
    }
  };

  return (
    <div className="loginMainContainer">
      <div className="loginImageContainer">
        <img
          src={require("../../../assets/login_bg.png")}
          className="loginBgImage"
          alt="login_bg"
        />
      </div>
      <div className="loginBoxContainer">
        <img
          src={require("../../../assets/logo.png")}
          className="logoImage"
          alt="logo"
        />
        <div className="brandLine">Empowering Partners, Renovating Homes</div>
        <div className="loginBox">
          <div className="loginLine">Login as an Admin</div>
          <div className="inputFeildContainer">
            <div className="inputFeildHeader">Email</div>
            <div className="inputFeildBg">
              <img
                src={require("../../../assets/emailIcon.png")}
                style={{ width: "1.3vw", height: "1.1vw" }}
                alt="loginIcon"
              />
              <input
                placeholder="Please enter a valid email"
                onChange={e => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="inputFeildContainer">
            <div className="inputFeildHeader">Password</div>
            <div className="inputFeildBg">
              <img
                src={require("../../../assets/passIcon.png")}
                style={{ width: "1vw", height: "1.2vw" }}
                alt="loginIcon"
              />
              <input
                placeholder="Please enter a valid password"
                type="password"
                onChange={e => setPassword(e.target.value)}
              />
            </div>
          </div>
          <div
            className="loginButton"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={handleLogin}
          >
            <LinearGradient
              gradient={["to left", "#7B32EE ,#03BAF9"]}
              className="inputFeildHeader"
              style={{ fontSize: "1.2vw,", fontWeight: "600" }}
            >
              Login
            </LinearGradient>

            <img
              src={require("../../../assets/login.png")}
              className="loginButtonIcon"
              alt="loginIcon"
            />
          </div>
        </div>
      </div>
      <img
        src={require("../../../assets/circle.png")}
        className="decorativeCircleImage"
        alt="decorative_circle"
      />
      <img
        src={require("../../../assets/circle.png")}
        className="decorativeCircleImage2"
        alt="decorative_circle"
      />
    </div>
  );
}
